import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';

export interface ConfirmDeleteUserData {
  userId: number;
  username: string;
  email?: string;
  customerId: number | string;
}

@Component({
  selector: 'app-confirm-delete-user',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './confirm-delete-user.component.html',
  styleUrl: './confirm-delete-user.component.scss',
})
export class ConfirmDeleteUserComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDeleteUserData,
    private dialogRef: MatDialogRef<ConfirmDeleteUserComponent>
  ) {}

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
